import { Autocomplete, Input } from '@fullscreendigital/carrefour-dex-fe'

export const getColumns = () => [
  {
    title: 'Societate',
    field: 'legalEntityName',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Locatie',
    field: 'storeName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'SAP ID',
    field: 'sapId',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Data ultimului raport zilnic',
    field: 'dateOfLastDailyReport',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true
  },
  {
    title: 'Categorie',
    field: 'wasteCategoryName',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true
  }
]

export const getFilters = (
  legalEntitiesOptions: AutocompleteOption[],
  shopOptions: AutocompleteOption[],
  categoryOptions: AutocompleteOption[]
) => [
  {
    name: 'legalEntity',
    value: '',
    filter: (
      <Autocomplete variant="outlined" label="Societate" options={legalEntitiesOptions || []} />
    ),
    type: 'autocomplete',
    label: 'Societate'
  },
  {
    name: 'storeIds',
    value: undefined,
    filter: (
      <Autocomplete variant="outlined" label="Magazine" options={shopOptions || []} multiple />
    ),
    type: 'autocomplete',
    label: 'Magazine'
  },
  {
    name: 'sapId',
    label: 'SAP ID',
    type: 'text',
    filter: <Input type="text" name="sapId" label="SAP ID" variant="outlined" value="" />
  },
  {
    name: 'categoryIds',
    value: undefined,
    filter: (
      <Autocomplete variant="outlined" label="Categorii" options={categoryOptions || []} multiple />
    ),
    type: 'autocomplete',
    label: 'Categorii'
  }
]
